module.exports = "https://web-assets.ifttt.com/packs/media/components/radius-7697fe20.svg";